import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4995c1b8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "slot" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "el-upload__text" }, [
  /*#__PURE__*/_createTextVNode("将文件拖到此处，或"),
  /*#__PURE__*/_createElementVNode("em", null, "点击上传")
], -1))
const _hoisted_3 = {
  key: 0,
  class: "el-upload__tip"
}
const _hoisted_4 = { style: {"display":"inline-block"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_upload_filled = _resolveComponent("upload-filled")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_alert = _resolveComponent("el-alert")!
  const _component_el_upload = _resolveComponent("el-upload")!

  return (_openBlock(), _createBlock(_component_el_upload, {
    action: _ctx.action,
    headers: _ctx.headers,
    "before-upload": _ctx.beforeUpload,
    "on-exceed": _ctx.onExceed,
    "on-success": _ctx.onSuccess,
    "on-error": _ctx.onError,
    "on-remove": _ctx.onRemove,
    "file-list": _ctx.files,
    limit: _ctx.max,
    drag: ""
  }, {
    tip: _withCtx(() => [
      (!_ctx.notip)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_el_alert, {
                title: `上传文件支持 ${_ctx.ext.join(' / ')} 格式，单个文件大小不超过 ${_ctx.size}MB，且文件数量不超过 ${_ctx.max} 个`,
                type: "info",
                "show-icon": "",
                closable: false
              }, null, 8, ["title"])
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_el_icon, { class: "el-icon--upload" }, {
          default: _withCtx(() => [
            _createVNode(_component_upload_filled)
          ]),
          _: 1
        }),
        _hoisted_2
      ])
    ]),
    _: 1
  }, 8, ["action", "headers", "before-upload", "on-exceed", "on-success", "on-error", "on-remove", "file-list", "limit"]))
}